import clsx from 'clsx';

import {Icon} from '../Icon';
import {ProtectedImage} from '../Protected';

import type {IconProp, SizeProp} from '@fortawesome/fontawesome-svg-core';

type Props = Pick<
  React.ComponentProps<typeof ProtectedImage>,
  'loadingPlaceholder'
> & {
  image: string | undefined | null;
  className?: string;
  children?: React.ReactNode;
} & (
    | {
        icon: IconProp;
        iconSize?: SizeProp;
        iconRaw?: never;
      }
    | {
        iconRaw: React.ComponentType<React.SVGProps<SVGSVGElement>>;
        icon?: never;
        iconSize?: never;
      }
  );
export function EntityThumbnail(props: Props): React.JSX.Element {
  return props.image ? (
    <div
      className={clsx(
        'relative flex items-center justify-center bg-slate3',
        props.className
      )}
    >
      <ProtectedImage
        src={props.image}
        alt="thumbnail image"
        className="h-full w-full object-cover object-center"
        loadingPlaceholder={props.loadingPlaceholder}
      />

      {props.children}
    </div>
  ) : (
    <div
      className={clsx(
        'relative flex items-center justify-center bg-slate4 fill-slate11 p-8 text-slate11',
        props.className
      )}
    >
      {props.icon ? (
        <Icon icon={props.icon} size={props.iconSize} />
      ) : (
        <props.iconRaw className="size-16" />
      )}

      {props.children}
    </div>
  );
}
